import * as React from 'react';
import { IClient, IDepotGeo, ICapacite, IClientSynthese } from '../models';
import { useData } from '../core/context/ProvidersContext';

export interface IClientDashboardData {
  clients: IClient[];
  depotsGeo: IDepotGeo[];
  capacites: ICapacite[];
  synthese: IClientSynthese[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useClientDashboard(selectedClientId: number | null): IClientDashboardData {
  const data = useData();
  const [clients, setClients] = React.useState<IClient[]>([]);
  const [depotsGeo, setDepotsGeo] = React.useState<IDepotGeo[]>([]);
  const [capacites, setCapacites] = React.useState<ICapacite[]>([]);
  const [synthese, setSynthese] = React.useState<IClientSynthese[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const loadAll = React.useCallback(() => {
    setLoading(true);
    setError(null);
    Promise.all([
      data.getClients(),
      data.getDepotsGeo(),
      data.getCapacites(selectedClientId || undefined),
      data.getClientSynthese(),
    ])
      .then(([c, d, cap, s]) => {
        setClients(c);
        setDepotsGeo(d);
        setCapacites(cap);
        setSynthese(s);
      })
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [data, selectedClientId]);

  React.useEffect(() => { loadAll(); }, [loadAll]);

  return { clients, depotsGeo, capacites, synthese, loading, error, refresh: loadAll };
}
